import { URI } from 'sip.js'

function createRandomToken(size, base = 32) {
    let token = ''
    for (let i = 0; i < size; i++) {
        const r = Math.floor(Math.random() * base)
        token += r.toString(base)
    }
    return token
}

export function initContact() {
    const contactName = this.options.contactName !== '' ? this.options.contactName : createRandomToken(8)
    const contactParams = this.options.contactParams
    const contactExtras = this.options.contactExtras
    const contact = {
        pubGruu: undefined,
        tempGruu: undefined,
        uri: new URI('sip', contactName, this.options.viaHost, undefined, contactParams),
        toString: function (contactToStringOptions = {}) {
            const anonymous = contactToStringOptions.anonymous || false
            const outbound = contactToStringOptions.outbound || false
            let contactString = '<'
            if (anonymous) {
                contactString +=
                    this.tempGruu ||
                    `sip:anonymous@anonymous.invalid;transport=${
                        contactParams.transport ? contactParams.transport : 'ws'
                    }`
            } else {
                contactString += this.pubGruu || this.uri
            }
            if (outbound) {
                contactString += ';ob'
            }
            contactString += '>'
            if(contactExtras) {
                for (const param in contactExtras) {
                    contactString += `;${param}="${contactExtras[param]}"`
                }
            }

            return contactString
        }
    }
    return contact
}
